import script from "./PageBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageBanner.vue?vue&type=script&lang=ts&setup=true"

import "./PageBanner.vue?vue&type=style&index=0&id=69abfde0&lang=scss"

const __exports__ = script;

export default __exports__